// extracted by mini-css-extract-plugin
module.exports =  {"tooltip-cursor":"TooltipCursor-component-module__tooltip-cursor___cuYrw"};